const data = {
  collection: [],
  currentPage: 1,
  loading: false,
  perPage: 6,
  timeout: null,
  totalRows: 0
}

const computed = {
  queryParams () {
    return {
      page: this.currentPage,
      per_page: this.perPage
    }
  }
}

const watch = {
  currentPage() {
    this.fetchCollection()
    this.scrollToTop()
  }
}

const methods = {
  onFilterChanges() {
    clearTimeout(this.timeout)

    this.loading = true
    this.timeout = setTimeout(() => {
      this.currentPage = 1
      this.fetchCollection()
    }, 500)
  },

  fetchCollection() {
    const params = this.queryParams || {}

    this.loading = true
    this.axios.get(this.url, { params }).then((response) => {
      this.totalRows = parseInt(response.headers.total)
      this.collection = response.data
    }).catch(() => {
      this.currentPage = false
      this.collection = []
      this.totalRows = 0
    }).finally(() => {
      this.loading = false
      if (params.groups != undefined){
        if (params.groups[0] == "event" && params.order == "most_older"){
          this.collection.sort((a, b) => new Date(a.event_start_time) - new Date(b.event_start_time))
        }
        else if (params.groups[0] == "event" && params.order == null){
          this.collection.sort((a, b) => new Date(a.event_start_time) - new Date(b.event_start_time)).reverse()
        }
      }
    })
  },

  scrollToTop() {
    this.$refs.container.scrollIntoView({ behavior: 'smooth', block: 'start'})
  }
}

export {
  data,
  computed,
  watch,
  methods
}
